import {
  SET_CONVERSATION_ATTRIBUTES,
  UPDATE_CONVERSATION_ATTRIBUTES,
  CLEAR_CONVERSATION_ATTRIBUTES,
  SET_CONVERSATION_LOAD
} from '../types';
import { getConversationAPI, setUserLastSeenAt } from '../../api/conversation';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const state = {
  id: undefined,
  status: '',
  performer: '',
  inbox_id: '',
  loading: false
};

export const getters = {
  getConversationParams: $state => $state
};

export const actions = {
  getAttributes: async ({ commit }) => {
    try {
      const { data } = await getConversationAPI();
      const { contact_last_seen_at: lastSeen } = data;
      commit(SET_CONVERSATION_ATTRIBUTES, data);
      commit('conversation/setMetaUserLastSeenAt', lastSeen, { root: true });
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },
  update: async ({ commit }, data) => {
    const lastSeen = Date.now() / 1000;
    commit('conversation/setMetaUserLastSeenAt', lastSeen, { root: true });
    await setUserLastSeenAt({ lastSeen });
    commit(UPDATE_CONVERSATION_ATTRIBUTES, data);
  },
  clearConversationAttributes: ({ commit }) => {
    commit('CLEAR_CONVERSATION_ATTRIBUTES');
  },
  setConversationload: ({ commit }, data ) => {
    commit(SET_CONVERSATION_LOAD, data);
  }
};

export const mutations = {
  [SET_CONVERSATION_ATTRIBUTES]($state, data) {
    $state.id = data.id;
    $state.status = data.status;
    $state.performer = data.performer;
    $state.inbox_id = data.inbox_id;
  },
  [UPDATE_CONVERSATION_ATTRIBUTES]($state, data) {
    if (data.id === $state.id || !$state.id) {
      $state.id = data.id;
      $state.status = data.status;
      $state.performer = data.performer;
      $state.inbox_id = data.inbox_id;
    }
  },
  [CLEAR_CONVERSATION_ATTRIBUTES]($state) {
    $state.id = undefined;
    $state.status = '';
    $state.performer = '';
    $state.inbox_id = '';
  },
  [SET_CONVERSATION_LOAD]($state, data){
    $state.loading = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
